module.exports = __webpack_public_path__ + "img/bot22.d89b0ee0.png";